import { useEffect, useRef, useContext, useState } from "react"
import { GpraContext } from "../../../context/gpraContext"
import { endpoints } from "../../../config/gpraApiEndpoints"
import { showMessage } from "../utils/utils"
import ProgramQuestions from "../Forms/H/ProgramQuestions/ProgramQuestions"
import { LoaderMedium } from "../../../components/Loaders"
import { INTERVIEW_SECTIONS } from "../types/interviewTypes"
import { UserContext } from "../../../context/userContext"

const ProgramQuestionsContainer = ({ showToolBar, disabled }) => {
  const { interview, handleSubmitGet, handleLoadPrev, loadCollection } =
    useContext(GpraContext)
  const userCtx = useContext(UserContext)

  const [isGettingProgramQuestions, setIsGettingProgramQuestions] =
    useState(true)

  const toast = useRef()

  useEffect(() => {
    if (interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id) {
      setIsGettingProgramQuestions(true)
      handleSubmitGet(endpoints.GET_PROGRAM_QUESTIONS_DATA, {
        gpra_interview_id:
          interview[INTERVIEW_SECTIONS.RECORD_MGMT].interview_id,
          organization_id: userCtx.session.user.organization_id,
        section: INTERVIEW_SECTIONS.PROGRAM,
      })
        .then((response) => {
          loadCollection(setValues(response.data), INTERVIEW_SECTIONS.PROGRAM)
          handleLoadPrev(false)
          setIsGettingProgramQuestions(false)
        })
        .catch((error) => {
          showMessage(false, error, toast)
          handleLoadPrev(false)
          setIsGettingProgramQuestions(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setValues = (data) => {
    return {
      gpra_h_1: data?.form?.gpraH1,
      gpra_h_2a1: data?.form?.gpraH2A1,
      gpra_h_2a2: data?.form?.gpraH2A2,
      gpra_h_2b1: data?.form?.gpraH2B1,
      gpra_h_2b2: data?.form?.gpraH2B2,
      gpra_h_2c1: data?.form?.gpraH2C1,
      gpra_h_2c2: data?.form?.gpraH2C2,
      gpra_h_2d1: data?.form?.gpraH2D1,
      gpra_h_2d2: data?.form?.gpraH2D2,
      gpra_h_3: data?.form?.gpraH3,
      gpra_h_id: data?.form?.gpraHId ?? 0,
      additional: data?.additional,
    }
  }

  if (isGettingProgramQuestions) {
    return <LoaderMedium></LoaderMedium>
  }
  return (
    <>
      {!isGettingProgramQuestions && (
        <ProgramQuestions showToolBar={showToolBar} disabled={disabled} />
      )}
    </>
  )
}
export default ProgramQuestionsContainer
